
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

interface ArticleNavigationProps {
  previousArticleLink?: string;
  previousArticleTitle?: string;
}

const ArticleNavigation = ({ previousArticleLink, previousArticleTitle }: ArticleNavigationProps) => {
  if (!previousArticleLink) return null;

  return (
    <div className="mt-8 border-t pt-6">
      <Link to={previousArticleLink}>
        <Button variant="outline" className="flex items-center gap-2">
          <ArrowLeft size={16} />
          {previousArticleTitle || "Read Previous Article"}
        </Button>
      </Link>
    </div>
  );
};

export default ArticleNavigation;
